import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import SearchBox from "../search-box/search-box.component";
import "./nav-options.styles.css";
import { IoBagHandleOutline } from "react-icons/io5";
import { FaRegUser } from "react-icons/fa";
import { CiBookmark } from "react-icons/ci";
import Button from "../button/button.component";
import translations from "../../translate";
import NavCartItem from "../nav-cart-items/nav-cart-item.component";

const NavOptions = ({ language, setLanguage }) => {
  const token = localStorage.getItem("access_token");

  const [cartItems, setCartItems] = useState([]);

  useEffect(() => {
    // خواندن اطلاعات از Local Storage هنگام بارگذاری کامپوننت
    const storedCart = JSON.parse(localStorage.getItem("cart")) || [];
    setCartItems(storedCart);

    // گوش دادن به رویداد سفارشی
    const handleCartUpdate = (event) => {
      setCartItems(event.detail); // به‌روزرسانی state سبد خرید
    };

    window.addEventListener("cartUpdated", handleCartUpdate);

    // پاکسازی گوش دادن به رویداد
    return () => {
      window.removeEventListener("cartUpdated", handleCartUpdate);
    };
  }, []);

  const handleLanguageChange = (e) => {
    setLanguage(e.target.value);
  };

  const handleDeleteItem = (id) => {
    const updatedCart = cartItems.filter((item) => item.id !== id); // حذف محصول بر اساس id
    setCartItems(updatedCart); // به‌روزرسانی state
    localStorage.setItem("cart", JSON.stringify(updatedCart)); // ذخیره در Local Storage

    // انتشار رویداد برای به‌روزرسانی کامپوننت‌های دیگر
    const cartUpdateEvent = new CustomEvent("cartUpdated", {
      detail: updatedCart,
    });
    window.dispatchEvent(cartUpdateEvent);
  };

  const navCartText = translations[language].navCart.title; // متن Cart
  const navCartEmptyText = translations[language].navCart.empty; // متن خالی بودن Cart
  const totalItems = cartItems.reduce(
    (total, item) => total + item.quantity,
    0
  );

  return (
    <div className="nav-options-wrapper">
      <SearchBox />
      <Link to="" className="cart-link">
        <span className="cart-link-text">{navCartText} </span>
        <span className="cart-link-icon">
          <IoBagHandleOutline />
        </span>
        <span className="cart-list-number">{totalItems}</span>
        <span className="cart-link-drop-box">
          {cartItems.length === 0 ? (
            <p className="cart-link-text">{navCartEmptyText}</p>
          ) : (
            <>
              {cartItems.map((item) => (
                <NavCartItem
                  key={item.id}
                  cat={item}
                  onDelete={handleDeleteItem}
                />
              ))}
              <div className="cart-link-total-price-box">
                <h4 className="cart-link-total-price-text">مجموع</h4>
                <p className="cart-link-total-price-number">
                  {cartItems
                    .reduce(
                      (total, item) => total + item.price * item.quantity,
                      0
                    )
                    .toLocaleString("fa-IR")}{" "}
                  تومان
                </p>
              </div>
              <Link to="/cart">
                <Button className="cart-link-button">دیدن سبد خرید</Button>
              </Link>
            </>
          )}
        </span>
      </Link>
      <Link
        to={token ? "/profile-page" : "/login-register"}
        className="profile-link"
      >
        <span className="cart-link-text">{token ? "حساب کاربری" : "ورود"}</span>
        <span className="cart-link-icon">
          <FaRegUser />
        </span>
      </Link>

      {/* انتخاب زبان */}
      <div className="language-selector">
        <select value={language} onChange={handleLanguageChange}>
          <option value="EN">🇺🇸 EN</option>
          <option value="FA">🇮🇷 FA</option>
        </select>
      </div>
    </div>
  );
};

export default NavOptions;
